var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactSubPage',{attrs:{"title":{ 'zh-CN': '加入我们', 'en-US': 'Careers' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }